





















































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { IWallet } from '~/store/inventory/types';
import ReceiveFunds from '~/components/Wallet/ReceiveFunds.vue';
import FullScreenDialog from '~/components/FullScreenDialog.vue';
import { TextOutput } from '~/mixins';

@Component({
  components: { ReceiveFunds, FullScreenDialog },
})
export default class InsufficientFunds extends Mixins(TextOutput) {
  @Prop(Array) wallets!: IWallet[];
  @Prop({ type: String, default: 'purchase' }) action!: string;
  @Prop({ type: Boolean, default: false }) multiple!: boolean;
  @Prop({ type: String, default: 'item' }) type!: string;
  @Prop(String) assetToTransfer!: string;
  @Prop(Function) readonly closeDialog!: () => void;
  @Prop(String) nodeNFTActionFeeCurrency!: string;

  @Prop({ type: Boolean, default: true })
  rounded!: boolean;

  @Getter('showBuyCoinScreens') readonly showBuyCoinScreens!: boolean;

  showReceive = false;
  showBuyWithCreditCard = false;

  get actionText() {
    return `${this.action}  ${
      this.multiple
        ? this.$t('components.wallet.insufficientFunds.actionTextPlural')
        : this.$t('components.wallet.insufficientFunds.actionTextSingle')
    } ${this.type}${this.multiple ? 's' : ''}`;
  }

  get assetToTransferText() {
    switch (this.action) {
      case 'purchase':
        return this.$t('components.wallet.insufficientFunds.payingWith', {
          assetToTransfer: this.filterGyriText(this.assetToTransfer),
        });
      case 'convert':
        return this.$t('components.wallet.insufficientFunds.converting', {
          assetToTransfer: this.filterGyriText(this.assetToTransfer),
        });
      case 'bridge':
        return this.$t('components.wallet.insufficientFunds.bridging', {
          assetToTransfer: this.filterGyriText(this.assetToTransfer),
        });
      case 'fulfill allowance':
        return this.$t('components.wallet.insufficientFunds.minting', {
          assetToTransfer: this.filterGyriText(this.assetToTransfer),
        });
      case 'mint':
        return this.$t('components.wallet.insufficientFunds.minting', {
          assetToTransfer: this.filterGyriText(this.assetToTransfer),
        });
      case 'mark':
        return this.$t('components.wallet.insufficientFunds.unlocking', {
          assetToTransfer: this.filterGyriText(this.assetToTransfer),
        });
      case 'reactivate':
        return this.$t('components.wallet.insufficientFunds.locking', {
          assetToTransfer: this.filterGyriText(this.assetToTransfer),
        });
      default:
        return this.$t('components.wallet.insufficientFunds.sending', {
          assetToTransfer: this.filterGyriText(this.assetToTransfer),
        });
    }
  }

  get differentFeeCurrency() {
    if (
      this.action === 'mint' ||
      this.action === 'mark' ||
      this.action === 'reactivate'
    ) {
      return null;
    }

    return this.assetToTransfer
      ? this.wallets.find(wallet => wallet.symbol !== this.assetToTransfer)
      : null;
  }

  get symbolText() {
    if (this.nodeNFTActionFeeCurrency) {
      if (this.nodeNFTActionFeeCurrency === 'GALA') {
        return 'GALA[GalaChain]';
      }
    }

    return this.wallets.length > 1
      ? this.wallets[0].symbol +
          ' ' +
          this.$t('components.wallet.insufficientFunds.and') +
          ' ' +
          this.wallets[1].symbol
      : this.wallets[0].symbol;
  }

  get headingText() {
    return this.action === 'purchase'
      ? (this.$t('components.wallet.insufficientFunds.purchaseMsg', {
          coinSymbol: this.filterGyriText(this.symbolText),
        }) as string)
      : (this.$t('components.wallet.insufficientFunds.transactionMsg', {
          coinSymbol: this.filterGyriText(this.symbolText),
        }) as string);
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
